// extracted by mini-css-extract-plugin
module.exports = {"error":"GenericError-module--error--78e4c2"};